import { render } from "./DashboardBellNotificationList.vue?vue&type=template&id=0d8cbd93"
import script from "./DashboardBellNotificationList.vue?vue&type=script&lang=js"
export * from "./DashboardBellNotificationList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DashboardBellNotificationList.vue"]])

export default __exports__